// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LAp6OI0NXWvePK {
  display: flex;
  flex-direction: column;
  padding: var(--ds-space-200, 16px);
  gap: var(--ds-space-250, 20px);
}
.QWBNFAt1NRwH42 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.AkrQAKjq8mGxHB {
  color: var(--ds-text-subtle, #6b778c);
  font-weight: var(--ds-font-weight-medium, 500);
  text-align: center;
}
.MpcpqRaqUA8xJQ {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-100, 8px);
}
.ia4vZ_5ZHbIN85 {
  border: 1px solid var(--ds-border, #091e4224);
}
.ia4vZ_5ZHbIN85.usX6lQpxLu3JoG {
  border-color: var(--ds-border-selected, #0c66e4);
  background-color: var(--ds-background-selected, #e4f0f6);
}
.ia4vZ_5ZHbIN85 .uVqIwiQ54dx4pv {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-space-025, 2px);
  width: 100%;
}
.ia4vZ_5ZHbIN85 .uVqIwiQ54dx4pv ._Fk2Hi4n8LGlIt {
  font-weight: var(--ds-font-weight-medium, 500);
}
.ia4vZ_5ZHbIN85 .uVqIwiQ54dx4pv .AqLdhv62RO2XNJ {
  color: var(--ds-text-subtle, #6b778c);
  font-size: 12px;
}
.ia4vZ_5ZHbIN85:hover {
  border: 1px solid var(--ds-border, #091e4224);
}
.ia4vZ_5ZHbIN85:hover.usX6lQpxLu3JoG {
  border-color: var(--ds-border-selected, #0c66e4);
}
.dqshv1akvFiI6O {
  display: flex;
  justify-content: flex-end;
}
`, ""]);
// Exports
export var sitePickerContainer = `LAp6OI0NXWvePK`;
export var sitePickerHeader = `QWBNFAt1NRwH42`;
export var noSites = `AkrQAKjq8mGxHB`;
export var siteList = `MpcpqRaqUA8xJQ`;
export var siteItem = `ia4vZ_5ZHbIN85`;
export var selected = `usX6lQpxLu3JoG`;
export var siteInfo = `uVqIwiQ54dx4pv`;
export var siteName = `_Fk2Hi4n8LGlIt`;
export var siteUrl = `AqLdhv62RO2XNJ`;
export var sitePickerActions = `dqshv1akvFiI6O`;
export default ___CSS_LOADER_EXPORT___;
